import { render, staticRenderFns } from "./SaveTemplate.vue?vue&type=template&id=50cc7c9e&scoped=true&"
import script from "./SaveTemplate.vue?vue&type=script&lang=js&"
export * from "./SaveTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc7c9e",
  null
  
)

export default component.exports